export function tenantApiPath(tenantId: string, path: string): string {
    if (!tenantId) {
        throw new Error("Cannot create a tenant-scoped API path without a tenant ID");
    }

    return `${tenantId}/${path.replace(/^\/+/, "")}`;
}
